import { FormBase } from 'core/components';

export default class NikoTemplateInvoiceNoteModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'invoiceNote',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_INVOICE_NOTE_MODAL.INVOICE_NOTE_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_INVOICE_NOTE_MODAL.INVOICE_NOTE_PLACEHOLDER',
                    rules: 'string'
                },
            ],
        };
    }
}
